// const isFacebookApp = () => {
//   let ua = navigator.userAgent || navigator.vendor || window.opera;
//   return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
// }

import moment from 'moment'

export default {
  monthlyPrice() {
    const monthDays =
      this.priceObject.bookingDays < 30 ? this.priceObject.bookingDays : 30
    const days = this.useMinPeriodPrice
      ? this.priceObject.minDays
      : this.priceObject.bookingDays
    if (this.priceObject && this.priceObject.bookingDays >= 26) {
      return Math.round((this.rentalPrice / days) * monthDays)
    }
    return null
  },

  rentalPrice() {
    return (
      parseInt(
        (this.useMinPeriodPrice &&
        this.priceObject.bookingMinPeriodPrice > this.priceObject.bookingPrice
          ? this.priceObject.bookingMinPeriodPrice
          : this.priceObject.bookingPrice) * 100
      ) / 100
    )
  },

  useMinPeriodPrice() {
    return this.priceObject.minDays > this.priceObject.bookingDays
  },

  reservationFee() {
    let reservationFee = Math.round(this.rentalPrice * 0.3)
    if (this.monthlyPrice && reservationFee > this.monthlyPrice) {
      return this.monthlyPrice
    }
    reservationFee = Math.round(reservationFee / 10) * 10
    return reservationFee
  },

  computedCsrFee() {
    if (this.priceObject && this.priceObject.longTermRentCsrFee > 0) {
      return this.priceObject.longTermRentCsrFee
    }
    if (this.priceObject && this.priceObject.csrFee > 0) {
      return this.priceObject.csrFee
    }
    return this.defaultCsrFee
  },

  bookingExtrasPrice() {
    return (this.bookingExtras || [])
      .map((bookingExtra, index) => {
        if (this.bookingExtrasSelected && this.bookingExtrasSelected[index]) {
          return bookingExtra.price * this.bookingExtrasSelected[index]
        }
        return 0
      })
      .reduce((x, y) => x + y)
  },

  finalPrice() {
    const cleaningFee = this.object.cleaningFee || this.cleaningFee
    return (
      parseInt(
        (cleaningFee +
          this.computedCsrFee +
          this.rentalPrice +
          this.lateCheckInFee +
          this.bookingExtrasPrice) *
          100
      ) / 100
    )
  },

  lateCheckInFee() {
    let fee = null
    if (this.bookingData.checkInTime) {
      const p = this.searchFilters.dateStart.split('.')
      const momentFriendly = p[2] + '-' + p[1] + '-' + p[0]
      const dayOfWeek = moment(momentFriendly).isoWeekday()

      let h = parseInt(this.bookingData.checkInTime.substr(0, 2))
      if (h < 10 && h >= 1) {
        fee = this.$i18n.t('very_late_checkin_price')
          ? parseInt(this.$i18n.t('very_late_checkin_price'))
          : 0
      } else if (h >= 20 || h < 1) {
        fee = this.$i18n.t('late_checkin_price')
          ? parseInt(this.$i18n.t('late_checkin_price'))
          : 0
      }
      if (dayOfWeek === 7 && (h >= 18 || h <= 9)) {
        fee = this.$i18n.t('sunday_late_checkin_price')
          ? parseInt(this.$i18n.t('sunday_late_checkin_price'))
          : 0
      }
    }
    return fee
  },
}
